const BannerTypeEnum = {
    SLIDER: 1,
    BACKGROUND_MENU: 2,
    ADS: 3,
    VERTICAL: 4
}
export default BannerTypeEnum